
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import {extend, cloneObject} from './../../zviz2/zviz/functions';
import {styleWords} from './../../styles';

import OtherFilter from './other';
import SearchFilter from './search';
import DateFilter from './date';
import MonthFilter from './month';
import ThemeFilter from './theme';
import ListFilter from './list';
import PanelBlueprint from './../elements/panel';
import About from './about';
import config from './../../config';

//import {LifeCycle} from './../zviz2/zviz/cycle';

class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);
    }

    render(renderer){
        // We have some logic here to reset specific theme filters on a source when the source changes to
        // precent confusing theme filters. However now it has been requested to also show evaluation themes
        // as part of details in lessons learned, good practice and recommendations, we do allow setting the
        // evaluation themes in these sources too.
        super.render(renderer);
        const source = state.get('source');
        const filter = state.get('filter');
        const allowedThemeCatFilter = {
            eval: ['theme_category'],
            planned: ['theme_category'],
            ll: ['ll_theme_category', 'theme_category'],
            gp: ['gp_theme_category', 'theme_category'],
            rec: ['rec_theme_category', 'theme_category']
        };
        const allowedThemeFilter = {
            eval: ['theme'],
            planned: ['theme'],
            ll: ['ll_theme', 'theme'],
            gp: ['gp_theme', 'theme'],
            rec: ['rec_theme', 'theme']
        };
        const availableThemeCats = Object.keys(allowedThemeCatFilter).reduce((acc, key) => {
            return acc.add(...allowedThemeCatFilter[key]);
        }, new Set());
        const availableThemes = Object.keys(allowedThemeFilter).reduce((acc, key) => {
            return acc.add(...allowedThemeFilter[key]);
        }, new Set());

        for(let f of availableThemeCats.values()){
            if(! allowedThemeCatFilter[source].includes(f) && filter[f]){
                state.set('filter.' + f, null);
            }
        }
        for(let f of availableThemes){
            if(! allowedThemeFilter[source].includes(f) && filter[f]){
                state.set('filter.' + f, null);
            }
        }
    }
}


let themeFilter = extend({
    listeners: [
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'source') )
    ],
    properties: {
        data: {title: (ctrl) => (
            config.data.dimensionTitles[state.get('source') == 'eval' || state.get('source') == 'planned' ? 'theme' : state.get('source') + '_theme']
        )}
    },
    private: {
        children: [
            extend({
                properties: {
                    data: {
                        name: (ctrl) => (state.get('source') == 'eval' || state.get('source') == 'planned' ? 'theme' : state.get('source') + '_theme'), 
                        hideTitle: true
                    },
                    style: { marginBottom: '0px', marginTop: '10px' }
                }
            }, ListFilter)
        ]
    }
}, PanelBlueprint);

let Blueprint = extend({
    type: Controller,
    listeners: [
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'filter') ),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'view') ),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'source') )
    ],
    properties: {
        style: {
            position: 'static',
            cssFloat: (ctrl) => ( (state.get('renderSize') == 'large')? 'left': 'none'),
            width: (ctrl) => ( (state.get('renderSize') == 'large')? '25%': 'auto'),
            marginTop: '20px'
        }
    },
    events: {  },
    children: [

        cloneObject(About),

        cloneObject(SearchFilter),

        (ctrl) => ( (state.get('source') == 'planned')? cloneObject(MonthFilter): [] ),

        (ctrl) => ( (state.get('source') != 'planned')? cloneObject(DateFilter): [] ),

        (ctrl) => ( (state.get('view') == 'regional')? []: extend({
            properties: {
                data: {
                    name: state.get('source') === 'eval' || state.get('source') === 'planned' ? 'theme_category' : state.get('source') + '_theme_category',
                    title: config.data.dimensionTitles[state.get('source') == 'eval' || state.get('source') == 'planned' ? 'theme' : state.get('source') + '_theme'],
                    dimensions: state.get('source') === 'eval' || state.get('source') === 'planned' ?
                            ['theme_category', 'theme'] :
                            [state.get('source') + '_theme_category', state.get('source') + '_theme']
                }
            }
        }, ThemeFilter) ),

        (ctrl) => ( (state.get('view') == 'regional')? []: extend({
            properties: {
                data: {
                    name: 'region',
                    title: 'Region',
                    dimensions: ['region', 'country']
                }
            }
        }, ThemeFilter) ),
        
        (ctrl) => ( (state.get('view') == 'regional')? cloneObject(themeFilter): [] ),

        cloneObject(OtherFilter)
    ]

}, Group);


export default Blueprint;
export {Controller, Blueprint};